/**
 * Function causing delay by provided value in milliseconds
 * @param milliseconds - number
 */
export const sleep = (milliseconds: number) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
